---
title: "ご利用条件"
path: "/ja/ご利用条件"
seoTitle: "ご利用条件 | Dutch Passion Thailand"
seoDescription: "Dutch Passion Thailand でカンナビスシードをご購入いただく際の、ご注文、お支払い、配送、キャンセル、返品に関する条件の概要です。ご注文の前にお読みください。"
---

> **この日本語版は要約であり、機械翻訳です。**法的に有効なのは
> [英語版のご利用条件](/terms-and-conditions)です。内容に相違がある場合は英語版が優先します。
> 本ページはネイティブによる確認を待っている段階です。

## 対象

本条件は dutchpassion.co.th でのご注文すべてに適用されます。ご注文の確定をもって、
本条件に同意いただいたものとみなします。

## ご注文とお支払い

表示価格はタイバーツ建てで、税込みです。代金引換、クレジット／デビットカード、
PromptPay、モバイルバンキングでお支払いいただけます。カード情報は決済代行会社
Omise に直接送信され、当サイトを経由しません。

## 配送

営業日15時までのご注文は当日発送します。梱包は匿名で、外装から中身がわかることは
ありません。配送はタイ国内に限ります。通常の郵便配送はバンコクを含むタイ全土で100バーツ、
お届けまで通常1〜3営業日です。バンコク市内では、追加オプションとして250バーツの当日配達を
ご利用いただけます。

## キャンセルと返品

発送前であれば、注文番号を添えてご連絡いただくことでキャンセルまたは変更が可能です。
シードは開封の有無にかかわらず返品をお受けしておらず、お届け済みのご注文の返金も
いたしません。商品に不備がある場合やご注文と異なる場合はご連絡ください。

## 準拠法

本条件はタイ王国の法律に準拠します。ご不明な点は info@dutchpassion.co.th までお問い合わせください。
